import React, { useState } from 'react';
import './TagSelector.css';

const CREATE_NEW_TAG = '__create_new_tag__';

const TagSelector = ({ selectedTags = [], existingTags = [], onChange }) => {
  const [newTag, setNewTag] = useState('');
  const [isCreatingTag, setIsCreatingTag] = useState(false);
  const availableTags = existingTags.filter(tag => !selectedTags.includes(tag));

  const addTag = (tag) => {
    const trimmedTag = tag.trim();
    if (trimmedTag && !selectedTags.includes(trimmedTag)) {
      onChange([...selectedTags, trimmedTag]);
    }
  };

  const removeTag = (tag) => {
    onChange(selectedTags.filter(selectedTag => selectedTag !== tag));
  };

  const handleTagSelect = (event) => {
    const value = event.target.value;
    if (!value) return;

    if (value === CREATE_NEW_TAG) {
      setIsCreatingTag(true);
      event.target.value = '';
      return;
    }

    addTag(value);
    event.target.value = '';
  };

  const handleAddNewTag = (event) => {
    event.preventDefault();
    addTag(newTag);
    setNewTag('');
    setIsCreatingTag(false);
  };

  return (
    <div className="tag-selector">
      <label htmlFor="tag-picker">Tags</label>
      <select id="tag-picker" defaultValue="" onChange={handleTagSelect}>
        <option value="" disabled>Add tag</option>
        {availableTags.map(tag => (
          <option key={tag} value={tag}>{tag}</option>
        ))}
        <option value={CREATE_NEW_TAG}>Create new tag</option>
      </select>

      {isCreatingTag && (
        <div className="new-tag-input">
          <input
            type="text"
            value={newTag}
            onChange={(event) => setNewTag(event.target.value)}
            placeholder="New tag name"
            aria-label="New tag name"
          />
          <button type="button" onClick={handleAddNewTag}>Add</button>
        </div>
      )}

      {selectedTags.length > 0 && (
        <div className="selected-tags" aria-label="Selected tags">
          {selectedTags.map(tag => (
            <span key={tag} className="tag">
              {tag}
              <button type="button" onClick={() => removeTag(tag)} aria-label={`Remove ${tag}`}>
                ×
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default TagSelector;
